import {
  amplitudeEventsLib,
  type FactoringContext,
  type FactoringMethodChangeParams,
  type FactoringTermSelectedParams,
  type FactoringEventParams,
  type FactoringStartParams,
  type FactoringRejectedParams,
  type FactoringErrorParams,
  type FactoringOtpSentParams,
  type FactoringOtpErrorParams,
  type FactoringPrescoringResultParams,
  type FactoringScoringApprovedParams,
  type FactoringResultShownParams,
} from '../amplitude-events';

/**
 * Воронка рассрочки уходит только в Amplitude: аналогов этих шагов у GA,
 * AppsFlyer и Bloomreach нет, а нативный мост про факторинг ничего не знает.
 */
export const getFactoringVariant = () =>
  amplitudeEventsLib.getFactoringVariant();

export const factoringMethodShown = (params: FactoringContext) =>
  amplitudeEventsLib.factoringMethodShown(params);

export const paymentMethodChanged = (params: FactoringMethodChangeParams) =>
  amplitudeEventsLib.paymentMethodChanged(params);

export const factoringTermSelected = (params: FactoringTermSelectedParams) =>
  amplitudeEventsLib.factoringTermSelected(params);

export const factoringDocsShown = (params: FactoringEventParams) =>
  amplitudeEventsLib.factoringDocsShown(params);

export const factoringDocsConfirmed = (params: FactoringEventParams) =>
  amplitudeEventsLib.factoringDocsConfirmed(params);

export const factoringStart = (params: FactoringStartParams) =>
  amplitudeEventsLib.factoringStart(params);

export const factoringOtpSent = (params: FactoringOtpSentParams) =>
  amplitudeEventsLib.factoringOtpSent(params);

export const factoringOtpError = (params: FactoringOtpErrorParams) =>
  amplitudeEventsLib.factoringOtpError(params);

export const factoringSigned = (
  params: FactoringEventParams & { was_already_signed: boolean },
) => amplitudeEventsLib.factoringSigned(params);

export const factoringPrescoringResult = (
  params: FactoringPrescoringResultParams,
) => amplitudeEventsLib.factoringPrescoringResult(params);

export const factoringPrescoringContinue = (params: FactoringEventParams) =>
  amplitudeEventsLib.factoringPrescoringContinue(params);

export const factoringScoringApproved = (
  params: FactoringScoringApprovedParams,
) => amplitudeEventsLib.factoringScoringApproved(params);

export const factoringScoringRejected = (params: FactoringRejectedParams) =>
  amplitudeEventsLib.factoringScoringRejected(params);

export const factoringBankRedirect = (params: FactoringEventParams) =>
  amplitudeEventsLib.factoringBankRedirect(params);

export const factoringResultShown = (params: FactoringResultShownParams) =>
  amplitudeEventsLib.factoringResultShown(params);

export const factoringError = (params: FactoringErrorParams) =>
  amplitudeEventsLib.factoringError(params);
